import React from 'react'
import { NotFoundContainer, ContentWrapper, Description, ButtonWrapper } from './NotFoundElements'
import CustomButton from '../CustomButton'
import Lottie from 'react-lottie';
import animation from './24454-404.json';

const NotFound = ({ history }) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <NotFoundContainer>
            <Lottie
                options={defaultOptions}
                height={320}
                width={320}
            />
            <ContentWrapper>
                <Description>Page Not Found</Description>
                <ButtonWrapper>
                    <CustomButton onClick={() => history.push('/')}>Back to Home</CustomButton>
                </ButtonWrapper>
            </ContentWrapper>
        </NotFoundContainer>
    )
}

export default NotFound
